import { Routes, Route } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./routes/Home";
import Contact from "./routes/Contact";
import Prints from "./routes/Prints";
import PrintPage from "./routes/PrintPage";
import CartProvider from "./CartContext";
import AboutUs from "./routes/AboutUs";
import Checkout from "./routes/Checkout";
import Page404 from "./routes/Page404";
import SuccessPage from "./routes/SuccessPage";

function App() {
  const [theme, setTheme] = useLocalStorage("theme" ? "dark" : "light");

  const switchTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
  };
  return (
    <CartProvider>
      <div
        className="App"
        data-theme={theme}
        style={{ background: "var(--primaryBackgroundColor)" }}
      >
        <Navbar theme={theme} switchTheme={switchTheme} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/prints" element={<Prints />} />
          <Route path="/prints/:title" element={<PrintPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success-page" element={<SuccessPage />} />
          <Route path="*" element={<Page404 />} />
          {/* <Route path="/test" element={<TestCheckout />} /> */}
        </Routes>
        <Footer theme={theme} />
      </div>
    </CartProvider>
  );
}

export default App;
